import { BaseController } from '../../../common/base/controller';
import { statusVerifyModalComponent } from './components/statusVerifyModal/statusVerifyModal.component';

export class StatusVerifyController extends BaseController {
  constructor(controllerService, configService, $uibModal, userFormService) {
    'ngInject';
    super({
      controllerService,
      configService,
      $uibModal,
      userFormService,
    });
  }

  $onInit() {
    this.dateOptions = {
      dateFormat: 'dd.MM.yyyy',
      showWeeks: false,
    };
    this.setLanguageOptions().then(() => {
      this.dateOptions.dateFormat = this.languageOptions.mediumDate;
    });

    let dates = this.getMinMaxDate();
    this.dateOptions.initDate = new Date(dates.initDate);
    this.dateOptions.maxDate = new Date(dates.minDate);
    this.dateOptions.minDate = new Date(dates.maxDate);

    this.$uibModal.open({
      component: statusVerifyModalComponent.name,
      size: 'modal-lg',
      windowClass: 'status-verify-modal',
    }).result;

    this.messages = {
      birthday: {
        date: 'app.ownerState.error.birthday',
        dateDisabled: 'app.ownerState.error.birthday.dateDisabled',
        min: 'app.ownerState.error.birthday.minvalue',
        max: 'app.ownerState.error.birthday.maxvalue',
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/components/status/verify/verify.controller.js